// extracted by mini-css-extract-plugin
export default {"ghostInputWrapper":"zwRuwH","ghostInput":"olHXzI"};